import { CHECKOUT_PATH, checkoutParamNames } from "@modules/checkout-path";
import { CONFIRMATION_PATH, confirmationParamNames } from "@modules/confirmation-path";
import { HOTEL_INFO_ROUTE_PATH, hotelInfoRouteParamNames } from "@modules/hotel-info-path";
import { HOTELS_PAGE_PATH, hotelsParamNames } from "@modules/hotels-page-route";
import { PAYMENT_PROCESSING_PATH, paymentProcessingParamNames } from "@modules/payment-processing-path";
import { TRIP_DETAILS_PATH, tripDetailsParamNames } from "@modules/trip-details-path";
import { matchPath } from "react-router";

const getHotelId = (value: string | undefined): number | undefined => {
  const hotelId = parseInt(value ?? "", 10);
  return Number.isFinite(hotelId) ? hotelId : undefined;
};

const getDealKey = (search: string): string | undefined => {
  return new URLSearchParams(search).get(checkoutParamNames.dealKey) ?? undefined;
};

export const resolveSentryBookingRouteContext = ({
  pathname,
  search,
}: {
  pathname: string;
  search: string;
}): {
  hotelId?: number;
  dealKey?: string;
  checkoutId?: string;
} => {
  const paymentProcessingRouteMatch = matchPath(PAYMENT_PROCESSING_PATH, pathname);
  if (paymentProcessingRouteMatch) {
    const dealKey = getDealKey(search);
    return {
      hotelId: getHotelId(paymentProcessingRouteMatch.params[paymentProcessingParamNames.hotelId]),
      checkoutId: paymentProcessingRouteMatch.params[paymentProcessingParamNames.checkoutId],
      ...(dealKey ? { dealKey } : {}),
    };
  }

  const checkoutRouteMatch = matchPath(CHECKOUT_PATH, pathname);
  if (checkoutRouteMatch) {
    const dealKey = getDealKey(search);
    return {
      hotelId: getHotelId(checkoutRouteMatch.params[checkoutParamNames.hotelId]),
      checkoutId: checkoutRouteMatch.params[checkoutParamNames.checkoutId],
      ...(dealKey ? { dealKey } : {}),
    };
  }

  const confirmationRouteMatch = matchPath(CONFIRMATION_PATH, pathname);
  if (confirmationRouteMatch) {
    return {
      hotelId: getHotelId(confirmationRouteMatch.params[confirmationParamNames.hotelId]),
    };
  }

  const tripDetailsRouteMatch = matchPath(TRIP_DETAILS_PATH, pathname);
  if (tripDetailsRouteMatch) {
    return {
      hotelId: getHotelId(tripDetailsRouteMatch.params[tripDetailsParamNames.hotelId]),
    };
  }

  const hotelInfoRouteMatch = matchPath(HOTEL_INFO_ROUTE_PATH, pathname);
  if (hotelInfoRouteMatch) {
    return {
      hotelId: getHotelId(hotelInfoRouteMatch.params[hotelInfoRouteParamNames.hotelId]),
    };
  }

  const hotelsRouteMatch = matchPath(HOTELS_PAGE_PATH, pathname);
  if (hotelsRouteMatch) {
    const dealKey = getDealKey(search);
    return {
      hotelId: getHotelId(hotelsRouteMatch.params[hotelsParamNames.hotelId_hotelName]),
      ...(dealKey ? { dealKey } : {}),
    };
  }

  return {};
};
